// WIB (UTC+7) helpers — independent of the browser's local timezone.
export function wibNow() {
  const now = new Date();
  return new Date(now.getTime() + (now.getTimezoneOffset() + 420) * 60000);
}

export function wibDateStr(d = wibNow()) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
